<template>
  <div class="col-sm-6 col-lg-3 stat-card-col">
    <div
      class="stat-card card-hover-rise"
      :class="{ 'cursor-pointer': statisticsItem[itemKey].data.url }"
      :style="{ backgroundColor: statisticsItem[itemKey].background_color }"
      @click="reDirect(statisticsItem[itemKey].data.url_type, statisticsItem[itemKey].data.url)"
    >
      <div class="stat-card-top">
        <span class="stat-label-badge">{{ statisticsItem[itemKey].data.name }}</span>
        <select v-if="statisticsItem[itemKey].data.is_filterable"
                @change.stop="$emit('onDateChange', statisticsItem[itemKey])"
                @click.stop
                v-model="statisticsItem[itemKey].period_type"
                class="stat-range-select">
          <option value="" disabled selected>Select Range</option>
          <option v-for="(range, j) in (statisticsItem[itemKey].data.time_ranges || timeRange)" :key="j" :value="range.value">{{ range.name }}</option>
        </select>
        <span v-else class="stat-see-all" @click.stop="navigate(statisticsItem[itemKey].data.url)">See All</span>
      </div>

      <div class="stat-card-body">
        <div class="stat-values truncate">
          <h4 class="stat-value" :class="{ 'stat-value-negative': isNegative(statisticsItem[itemKey].data.value) }">
            {{ commaFormat(statisticsItem[itemKey].data.value) }}
          </h4>
          <p v-if="hasSecondaryValue(statisticsItem[itemKey].data)" class="stat-secondary">
            {{ statisticsItem[itemKey].data.secondary_label }}: {{ commaFormat(statisticsItem[itemKey].data.secondary_value) }}
          </p>
        </div>
        <span v-if="! iconLoadFailed[itemKey]" class="stat-icon-badge">
          <img
            :src="`/app-assets/images/icons/dashboard/${itemKey}.png`"
            alt=""
            @error="onIconError(itemKey)"
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive} from "vue";
import figureFormatter from "@/services/utils/figureFormatter";
import {useRoute, useRouter} from "vue-router";
import handleRedirectToPage from "@/services/modules/redirectToPage";
import useDate from "@/services/utils/day";

const router = useRouter();
const route = useRoute();

const {commaFormat} = figureFormatter()
const {goToPage} = handleRedirectToPage()

const {firstDateOfMonth, lastDateOfMonth} = useDate()

const props = defineProps({
  statisticsItem: Object,
  page: Object,
  timeRange: Array,
  itemKey: String
})

const hasSecondaryValue = (data) => {
  if (!data) return false
  return data.secondary_value !== undefined && data.secondary_value !== null
}

const iconLoadFailed = reactive({})

const onIconError = (itemKey) => {
  iconLoadFailed[itemKey] = true
}

const isNegative = (value) => {
  return Number(value) < 0
}

const reDirect = (urlType='', url='') => {
  switch (urlType) {
    case 'internal':
      navigate(url);
      break;
    case 'external':
      goToPage(url);
      break;
  }
}

const navigate = (url) => {
  const item = props.statisticsItem && props.itemKey ? props.statisticsItem[props.itemKey] : null;
  const start = item && item.period_start ? item.period_start : firstDateOfMonth;
  const end = item && item.period_end ? item.period_end : lastDateOfMonth;
  const pageId = item && item.data && item.data.page_id ? item.data.page_id : null;

  const params = { ...route.params };
  if (pageId) {
    params.pageId = pageId;
  }

  router.push({
    name: url,
    params: params,
    query: { start, end }
  });
}

const accentTint = (backgroundColor) => {
  if (! backgroundColor) return '#16a08540'
  return backgroundColor.slice(0, 7) + '40'
}
</script>

<style scoped>
.stat-card-col {
  padding: 8px;
}

.stat-card {
  min-height: 150px;
  background-color: #ffffff;
  border: 1px solid #e8e9ec;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.06);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.card-hover-rise {
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.card-hover-rise:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(34, 41, 47, 0.12);
}

.stat-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: #fafbfc;
  border-radius: 8px 8px 0 0;
  padding: 14px 20px;
  margin: -18px -20px 0;
  box-shadow: 0 2px 8px rgba(34, 41, 47, 0.08);
  position: relative;
  z-index: 1;
}

.stat-label-badge {
  font-size: 13px;
  font-weight: 600;
  color: #6e6b7b;
}

.stat-range-select {
  border: 1px solid #eceef1;
  border-radius: 6px;
  background-color: #f8f9fa;
  font-size: 11px;
  padding: 3px 6px;
  color: #6e6b7b;
}

.stat-see-all {
  font-size: 12px;
  font-weight: 600;
  color: #16a085;
  cursor: pointer;
}

.stat-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.stat-values {
  text-align: left;
}

.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #2b2b2b;
  margin: 0;
}

.stat-value-negative {
  color: #ea5455;
}

.stat-secondary {
  font-size: 12px;
  color: #8a8a8a;
  margin: 4px 0 0;
}

.stat-icon-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon-badge img {
  width: 40px;
  height: 40px;
}
</style>
